import React from 'react';
import SkillBadge from './SkillBadge';

function Skills({ skills }) {
  return (
    <div className="skills">
      <h3>Skills</h3>
      <div className="skills-list">
        {skills.map(skill => (
          <SkillBadge 
            key={skill.name}
            name={skill.name}
            level={skill.level}
          />
        ))}
      </div>
    </div>
  );
}

export default Skills;